import { useMutation, useQueryClient } from "@tanstack/react-query";

import { AltiusErrors, PlaidConnection } from "store/types";
import { usePlaidQueries } from "../query-context";

export const useDeleteConnectionMutation = () => {
  const queryClient = useQueryClient();
  const { deleteConnection } = usePlaidQueries();

  return useMutation<void, AltiusErrors, number>(
    (connectionId) => {
      return deleteConnection(connectionId); // Skip saving data in DB
    },
    {
      onSettled: () => {
        queryClient.invalidateQueries(["plaid-connections"]);
      }
    }
  );
};

export const useSyncInvestmentHoldings = () => {
  const { syncInvestmentHoldings } = usePlaidQueries();
  const queryClient = useQueryClient();

  return useMutation<PlaidConnection, AltiusErrors, string>(
    (itemId) => syncInvestmentHoldings(itemId, new Date("2020-01-01")),
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries(["plaid-connection-deals", data.id]);
      }
    }
  );
};
